import React from "react";
import "./values.scss";
import parse from "html-react-parser";
import { graphql } from "gatsby";

export interface ValuesItemData {
  text: string;
  title: string;
  icon: {
    sourceUrl: string;
  };
}

interface Props {
  values: ValuesItemData[];
}

export const query = graphql`
  fragment ValuesBlock on WpAcfValuesBlock {
    AcfValues {
      values {
        text
        title
        icon {
          sourceUrl
        }
      }
    }
  }
`;

const Values: React.FC<Props> = (props) => {
  return (
    <div className="values">
      {props.values.map((item, key) => (
        <div className="values-item" key={key}>
          <div className="values-item__icon">
            <img src={item.icon.sourceUrl} />
          </div>
          <h3 className="typo-h-redline">{item.title}</h3>
          <div className="values-item__copy">{!!item.text && parse(item.text)}</div>
        </div>
      ))}
    </div>
  );
};

export default Values;
